import type { LucideIcon } from "lucide-react";
import {
	ArrowUpFromLine,
	Code,
	CreditCard,
	LayoutDashboard,
	Link as LinkIcon,
	MessageCircle,
	Receipt,
	Settings,
	Users,
	Wallet,
} from "lucide-react";

export interface Entity {
	id: string;
	label: { singular: string; plural: string };
	icon: LucideIcon;
	color: string;
}

export const entities = {
	dashboard: {
		id: "dashboard",
		label: { singular: "Dashboard", plural: "Dashboard" },
		icon: LayoutDashboard,
		color: "#6366f1",
	},
	orders: {
		id: "orders",
		label: { singular: "Order", plural: "Orders" },
		icon: Receipt,
		color: "#6366f1",
	},
	payments: {
		id: "payments",
		label: { singular: "Payment", plural: "Payments" },
		icon: CreditCard,
		color: "#14b8a6",
	},
	payment_links: {
		id: "payment_links",
		label: { singular: "Payment Link", plural: "Payment Links" },
		icon: LinkIcon,
		color: "#8b5cf6",
	},
	customers: {
		id: "customers",
		label: { singular: "Customer", plural: "Customers" },
		icon: Users,
		color: "#3b82f6",
	},
	finances: {
		id: "finances",
		label: { singular: "Finance", plural: "Finances" },
		icon: Wallet,
		color: "#f59e0b",
	},
	withdrawals: {
		id: "withdrawals",
		label: { singular: "Withdrawal", plural: "Withdrawals" },
		icon: ArrowUpFromLine,
		color: "#0ea5e9",
	},
	developer: {
		id: "developer",
		label: { singular: "Developer", plural: "Developer" },
		icon: Code,
		color: "#10b981",
	},
	support: {
		id: "support",
		label: { singular: "Support", plural: "Support" },
		icon: MessageCircle,
		color: "#06b6d4",
	},
	settings: {
		id: "settings",
		label: { singular: "Settings", plural: "Settings" },
		icon: Settings,
		color: "#6b7280",
	},
} as const satisfies Record<string, Entity>;

export type EntityId = keyof typeof entities;

export const entityList: Entity[] = Object.values(entities);

const SINGULAR_ALIASES: Record<string, EntityId> = {
	order: "orders",
	payment: "payments",
	payment_link: "payment_links",
	customer: "customers",
	withdrawal: "withdrawals",
};

export const getEntity = (id: string): Entity | undefined => {
	const key = id.toLowerCase().replace(/-/g, "_");
	if (key in entities) return entities[key as EntityId];
	const plural = SINGULAR_ALIASES[key];
	return plural ? entities[plural] : undefined;
};
